/**
 * Currency handling for the Cost Scheme board.
 *
 * The board tracks a single currency per part (shared by its pax + group cost). We only support the
 * fixed set the planner uses; anything the server sends that is outside the set is normalized to the
 * default so the currency `<select>` always has a valid value.
 */

export const CURRENCIES = ['CZK', 'EUR', 'PLN', 'USD'] as const;
export type Currency = (typeof CURRENCIES)[number];
export const DEFAULT_CURRENCY: Currency = 'CZK';

/** Coerce an arbitrary server currency string to one of {@link CURRENCIES}, defaulting to CZK. */
export function normalizeCurrency(value: string | null | undefined): Currency {
  const found = CURRENCIES.find((c) => c === value);
  return found ?? DEFAULT_CURRENCY;
}
